<template>
  <v-container
    fluid
    class="secondary fill-height"
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col cols="6">
        <!-- login card -->
        <v-card
          rounded="lg"
          class="pa-5"
        >
          <!-- login form -->
          <div class="d-block font-weight-bold text-md-center mb-3" v-if="error != ''">
            <span class="red--text">{{ error.error }} <br/>Try the old login instead &nbsp;</span>
            <a :href="`/login?login_key=${login_key}`">HERE</a>
          </div>
          <v-form @submit.prevent="login">
            <div class="primary--text text-md-center font-weight-bold text-h5">
              Login Via Microsoft
            </div>
            <!-- login button -->
            <v-card-actions>
              <v-btn
                large
                rounded
                color="primary"
                width="100%"
                type="submit"
                class="mx-auto"
                :disabled="loading"
              >
              <v-icon
                dark
                left
              >
                mdi-microsoft
              </v-icon>
                Login
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
        <!-- loading prompt -->
        <v-progress-linear
          color="primary"
          indeterminate
          :active="loading"
        ></v-progress-linear>
      </v-col> 
    </v-row>
  </v-container>
</template>

<script>
  
  // will be used when ready
  import API from '@/api'
  const User = API.get('User');

  export default {
    Name: 'Login',

    data: ()=>({
      username: '',
      password: '',
      error: '',
      success: '',
      loading: false,
      login_key: localStorage.getItem('login_session_key')
    }),

    methods: {
      async login () {
        this.loading = true;
        
        try {
          // testdata
          var response = await User.mslogin();
          if (response.status == 200) {
            window.location.href = response.data.url;
          }
        }
        catch(error) {
          this.error = error.response.data;
          console.log(this.error)
        }

        this.loading = false;
      },
      /**
       * Reset Password
       */
    }
  }
</script>

<style lang="scss" scoped>
  .no-underline {
    text-decoration: none;
  }
</style>